<div class="search-page__container container">
  @if (searchResults.length > 0 && isActiveSearch) {
    <h1 class="search-page__header" i18n="@@searchResultsTitle">Results for "{{ queryString }}"</h1>
  }

  <div class="search-page__filters-top">
    <div class="search-page__filters-show col-lg-3 col-sm-4"></div>
    <div class="search-page__count">
      <span>{{ totalProducts }}</span>
      <span i18n="@@TOTAL_PRODUCTS">{totalProducts, plural, =1 {Product} other {Products}}</span>
    </div>
    <div class="search-page__filters-sort col-lg-3 col-sm-4">
      <app-search-filter [filterCriteria]="'sort'" />
    </div>
  </div>

  @if (searchResults.length === 0 && isActiveSearch) {
    <div class="search-page__empty">
      <h2 i18n="@@noSearchResultsQuery">There were no results for "{{ queryString }}"</h2>
      <p i18n="@@noSearchResults.title">Use our search suggestions and try again:</p>
      <ul>
        <li i18n="@@noSearchResults.spelling">Check the spelling.</li>
        <li i18n="@@noSearchResults.keywords">Use one or two keywords.</li>
        <li i18n="@@noSearchResults.term">Try a different search term.</li>
      </ul>
    </div>
  }

  <app-product-list
    [products]="searchResults"
    [metaproducts]="metaproductsRequested"
    [isInWishlist]="isInWishlist"
    [productRequested]="productRequested"
    [colorReferences]="colorReferences"
    [displaySpecificProductCampaignHighlights]="true"
    (getProductById)="onGetProductById($event)"
    (addToWishlistEvent)="addToWishlistEventHandler()"
    (removeFromWishlistEvent)="removeFromWishlistEventHandler()"
    (setWishlistedProductEvent)="setWishlistedProductEventHandler($event)"
    (getMetaproductsEventHandler)="getMetaproducts($event)"
  />

  <app-pagination
    [paginationType]="'loadMore'"
    [currentPage]="currentOffset"
    [showNextPage]="showNextPage"
    [showLoadMore]="showLoadMore"
    (previousPageEvent)="previousPageEventHandler()"
    (nextPageEvent)="nextPageEventHandler()"
    (loadMoreEvent)="loadMoreEventHandler()"
  />
</div>
